import React, { Component } from 'react';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import i18n from '~/i18n';

class SaveChangesDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        return (
            <div>
                <h4 className="mar-b25">{i18n.t('saveChangesTitle')}</h4>
                <p>{i18n.t('saveChangesPrompt')}</p>

                <div className="quickFlex">
                    <Button className="button-md primary mar-r5" text={i18n.t('yes')} onClick={() => { this.props.confirm(true) }} />
                    <Button className="button-md secondary" text={i18n.t('no')} onClick={() => { this.props.confirm(false) }} />
                </div>

            </div>
        );
    }
}

export default SaveChangesDrawer;
